import { fetchPosService } from "../fetchPosService";
import type {
  CartReCreateMutation,
  CartReCreateMutationVariables,
  PosCartInput,
} from "../generates";
import { CartReCreateDocument } from "../types";

export const reCreateCart = async (
  input: PosCartInput,
  storeCode?: string,
): Promise<CartReCreateMutation> => {
  return fetchPosService<CartReCreateMutation, CartReCreateMutationVariables>({
    query: CartReCreateDocument,
    variables: {
      input,
    },
    store: storeCode,
  });
};
